// 転職支援サービスの流れ
function ScrollTimelineAnime() {
  $('.timeline li').each(function(){
    var elemPos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    var startPoint = 100;
    if (scroll >= elemPos - windowHeight-startPoint){
      var H = $(this).outerHeight(true)

      var percent = (scroll+startPoint - elemPos) / (H/2) *100;


      if(percent  > 100){
        percent  = 100;
      }
      $(this).children('.border-line').css({
        height: percent + "%", //CSSでパーセント指定
      });
    }
  });
}

$(function () {
  $(window).on('scroll', function(){
    ScrollTimelineAnime();
  });

  $(window).on('load', function(){
    ScrollTimelineAnime();
  });

  // サイトマップ
  //開くボタンを押した時には
  $(".sitemap").click(function () {
      $("#site-map-wrap").addClass('panelactive');//#site-map-wrapへpanelactiveクラスを付与
    $('#site-map-text').focus();//テキスト入力のinputにフォーカス
  });

  //閉じるボタンを押した時には
  $(".close-btn").click(function () {
      $("#site-map-wrap").removeClass('panelactive');//#site-map-wrapからpanelactiveクラスを除去
  });

  //アコーディオンをクリックした時の動作
  $('.titles').on('click', function() {//タイトル要素をクリックしたら
    $('.boxs').fadeOut(100);//クラス名.boxがついたすべてのアコーディオンを閉じる

    var findElm = $(this).next(".boxs");//タイトル直後のアコーディオンを行うエリアを取得

    if($(this).hasClass('close')){//タイトル要素にクラス名closeがあれば
      $(this).removeClass('close');//クラス名を除去
    }else{//それ以外は
      $('.close').removeClass('close'); //クラス名closeを全て除去した後
      $(this).addClass('close');//クリックしたタイトルにクラス名closeを付与し
      $(findElm).show();//アコーディオンを開く
    }
  });
});

// ウィンドウサイズが960px以下の時のmenu-parentの開閉
$(function () {
  if ($(window).width() < 960) {
    // ボタンをクリックしたら発動
    $('li.menu-parent').click(function () {
      // もしチェックが入っていたら
      if ($('input', this).prop('checked')) {
        // チェックを外す
        $('input', this).prop('checked', false);
        // もしチェックが外れていたら
      } else {
        // チェックを入れる
        $('input', this).prop('checked', true);
      }
    });
  }
});
